import { render, staticRenderFns } from "./IconFund.vue?vue&type=template&id=1debe270&functional=true&"
import script from "./IconFund.vue?vue&type=script&lang=js&"
export * from "./IconFund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports